import { render, staticRenderFns } from "./DailyMenuShiftMeals.vue?vue&type=template&id=1fcaa7ae"
import script from "./DailyMenuShiftMeals.vue?vue&type=script&lang=js"
export * from "./DailyMenuShiftMeals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports